import { HUBSPOT_COOKIES_PROVIDER, HUBSPOT_FORMS_COOKIES_PROVIDER } from "utils/_constants";

export const advertisingData = [
  { cookie: "__ptq.gif", provider: HUBSPOT_COOKIES_PROVIDER },
  { cookie: "_fbp", provider: "yulife.com" },
  { cookie: "_gcl_au", provider: "yulife.com" },
  { cookie: "ads/ga-audiences", provider: "google.com" },
  { cookie: "bcookie", provider: "linkedin.com" },
  { cookie: "bscookie", provider: "linkedin.com" },
  { cookie: "C", provider: "adform.net" },
  { cookie: "fr", provider: "facebook.com" },
  { cookie: "IDE", provider: "doubleclick.net" },
  { cookie: "lang", provider: "linkedin.com" },
  { cookie: "lidc", provider: "linkedin.com" },
  { cookie: "pagead/1p-user-list/#", provider: "google.com" },
  { cookie: "tr", provider: "facebook.com" },
  { cookie: "uid", provider: "adform.net" },
  { cookie: "UserMatchHistory", provider: "linkedin.com" },
];

export const analyticsData = [
  { cookie: "lang", provider: "ads.linkedin.com" },
  { cookie: "__hssc", provider: "yulife.com" },
  { cookie: "__hssrc", provider: "yulife.com" },
  { cookie: "__hstc", provider: "yulife.com" },
  { cookie: "_ga", provider: "yulife.com" },
  { cookie: "_gat", provider: "yulife.com" },
  { cookie: "_gid", provider: "yulife.com" },
  { cookie: "AnalyticsSyncHistory", provider: "linkedin.com" },
  { cookie: "hubspotutk", provider: "yulife.com" },
];

export const necessaryData = [
  { cookie: "__cf_bm", provider: HUBSPOT_COOKIES_PROVIDER },
  { cookie: "bugsnag-anonymous-id", provider: "yulife.com" },
  { cookie: "embed/v3/counters.gif", provider: HUBSPOT_FORMS_COOKIES_PROVIDER },
  { cookie: "li_gc", provider: "linkedin.com" },
  { cookie: "test_cookie", provider: "doubleclick.net" },
];
